var map = {
	"./config.demo.json": [
		33079,
		3079
	],
	"./config.dev.json": [
		33570,
		3570
	],
	"./config.local.json": [
		79399,
		9399
	],
	"./config.prod.json": [
		4934,
		4934
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 60719;
module.exports = webpackAsyncContext;